function sendSignInInfo({ state, output, services }) {
  let credentials = state.get('client.registrating.current.login')
  services.Http
    .post('/api/signin', {
      username: credentials.username.value,
      password: credentials.password.value
    })
    .then(output.success)
    .catch(output.error)
}

sendSignInInfo.async = true
export default sendSignInInfo



// WEBPACK FOOTER //
// ./src/modules/login/actions/sendSignInInfo.js